import { requireTranslations } from '../../../common/translation';

export default requireTranslations((locale: string) => require(`./articles.${locale}.json`));
